var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as brandFactory from '../../../classes/definitions/brand/brand';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import brandSchema from '../../../schemas/brandSchema';
import Input from '../../UI/Input/Input';
var BrandForm = /** @class */ (function (_super) {
    __extends(BrandForm, _super);
    function BrandForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.imageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(brandSchema),
            formIsValid: false,
            discardPopupVisble: false,
        };
        _this.getBrand = function (id) {
            _this.api
                .getBrand(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на метод на плащане';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var brand = brandFactory.createBrand(_.get(data, 'attributes', {}));
            var logoUrl = brand.LogoUrl ? Config.cdnDomain + brand.LogoUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'name.value', brand.Name);
            _.set(updatedFormConfig, 'name.touched', true);
            _.set(updatedFormConfig, 'name.valid', true);
            _.set(updatedFormConfig, 'slug.value', brand.Slug);
            _.set(updatedFormConfig, 'slug.touched', true);
            _.set(updatedFormConfig, 'slug.valid', true);
            _.set(updatedFormConfig, 'position.value', brand.Position ? brand.Position : null);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'description.value', brand.Description);
            _.set(updatedFormConfig, 'description.touched', true);
            _.set(updatedFormConfig, 'description.valid', true);
            _.set(updatedFormConfig, 'logo_url.value', logoUrl);
            _.set(updatedFormConfig, 'logo_url.touched', true);
            _.set(updatedFormConfig, 'logo_url.valid', true);
            _.set(updatedFormConfig, 'meta_title.value', brand.MetaTitle);
            _.set(updatedFormConfig, 'meta_title.touched', true);
            _.set(updatedFormConfig, 'meta_title.valid', true);
            _.set(updatedFormConfig, 'meta_description.value', brand.MetaDescription);
            _.set(updatedFormConfig, 'meta_description.touched', true);
            _.set(updatedFormConfig, 'meta_description.valid', true);
            _.set(updatedFormConfig, 'black_border.value', brand.BlackBorder);
            _.set(updatedFormConfig, 'black_border.touched', true);
            _.set(updatedFormConfig, 'black_border.valid', true);
            _.set(updatedFormConfig, 'hidden.value', brand.hidden);
            _.set(updatedFormConfig, 'hidden.touched', false);
            _.set(updatedFormConfig, 'hidden.valid', false);
            _.set(updatedFormConfig, 'bg_seo_description.value', brand.BgDescriptionSEO);
            _.set(updatedFormConfig, 'bg_seo_description.touched', true);
            _.set(updatedFormConfig, 'bg_seo_description.valid', true);
            _.set(updatedFormConfig, 'en_seo_description.value', brand.EnDescriptionSEO);
            _.set(updatedFormConfig, 'en_seo_description.touched', true);
            _.set(updatedFormConfig, 'en_seo_description.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            if (elType === 'checkbox') {
                updatedFormElement.value = event.checked;
            }
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'logo_url' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) }, function () {
                console.log(_this.state.formConfig);
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedBrands = new FormData();
            var image = _.get(formData, 'logo_url.value', null);
            submittedBrands.append('brand[name]', _.get(formData, 'name.value', ''));
            submittedBrands.append('brand[slug]', _.get(formData, 'slug.value', ''));
            submittedBrands.append('brand[position]', _.get(formData, 'position.value', ''));
            submittedBrands.append('brand[description]', _.get(formData, 'description.value', ''));
            submittedBrands.append('brand[meta_description]', _.get(formData, 'meta_description.value', ''));
            submittedBrands.append('brand[meta_title]', _.get(formData, 'meta_title.value', ''));
            submittedBrands.append('brand[black_border]', _.get(formData, 'black_border.value', ''));
            submittedBrands.append('brand[hidden]', _.get(formData, 'hidden.value', ''));
            submittedBrands.append('brand[bg_seo_description]', _.get(formData, 'bg_seo_description.value', ''));
            submittedBrands.append('brand[en_seo_description]', _.get(formData, 'en_seo_description.value', ''));
            if (_this.editId && _this.imageChanged && !image) {
                submittedBrands.append('brand[remove_logo]', '1');
            }
            else if (_this.editId && _this.imageChanged && image) {
                submittedBrands.append('brand[logo]', image);
            }
            else if (!_this.editId.length && _this.imageChanged && image) {
                // probably pointless, have to test
                submittedBrands.append('brand[logo]', image);
            }
            var actionMethod = _this.editId === '-1' ? _this.api.createBrand : _this.api.updateBrand;
            actionMethod(submittedBrands, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toBrandsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на метод на плащане';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toBrandsPage = function () {
            _this.props.history.push(AppRoutes.brands.path);
        };
        return _this;
    }
    BrandForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.brandId', '-1');
        if (this.editId !== '-1') {
            this.props.isEdit(true);
            this.getBrand(this.editId);
        }
    };
    BrandForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toBrandsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return BrandForm;
}(React.Component));
// @ts-ignore
export default withRouter(BrandForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Brands/BrandForm/BrandForm.tsx
// module id = 535
// module chunks = 0